<template>
  <div>
    <el-card style="height:70px">
      <el-button type="success" style="width:80px" plain @click="add" class="el-icon-circle-check" size="small">添加</el-button>
      <el-button type="danger" plain @click="Delete" style="width:80px" class="el-icon-circle-close" size="small">删除</el-button>
      <el-button type="primary" @click="select" size="small" style="float:right">刷新</el-button>
    </el-card>
    <el-card style="height:800px;margin-top:7px">
      <el-table :data="tableData" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" height="721px">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="titlestr" label="标题" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="body" label="内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" label="类型" width="100" align="center">
          <template #default="{row}">
            <div v-if="row.type === 0" style="color:#67C23A">公告</div>
            <div v-else style="color:#67C23A">通知</div>
          </template>
        </el-table-column>
        <el-table-column prop="writerId" label="发布人编号" width="200"></el-table-column>
        <el-table-column prop="createTimeStr" label="创建时间" width="105" align="center"></el-table-column>
      </el-table>
      <el-dialog :visible.sync="dialogVisible" width="50%" top="8vh" center :close-on-click-modal="false">
        <el-form :model="form2" label-width="100px" v-if="dialogVisible">
          <el-form-item label="标题：">
            <el-input v-model="form2.title" style="width:95%"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="form2.type" style="width:95%">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公告内容：">
            <el-input type="textarea" style="width:95%" v-model="form2.body" placeholder="公告内容字数2000字以内" rows="12" show-word-limit :maxlength="2000"></el-input>
          </el-form-item>
          <div style="text-align:center">
            <el-button type="info" size="small" @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" size="small" @click="isAdd">确定</el-button>
          </div>
        </el-form>
      </el-dialog>
      <!-- 分页 -->
      <div class="block" style="margin-top:15px;text-align:center;">
        <el-pagination
          @current-change="handleCurrentChange1"
          @size-change="handleSizeChange"
          :current-page="form.page"
          :page-size="6"
          :page-sizes="[14,50,500,1000]"
          layout="sizes, total,  prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  name: 'NoticeManager',
  data () {
    return {
      total: 0,
      tableData: [],//表格数据
      multipleSelection: [],//选中
      auditOpinion: '',
      options: [
        {
          id: 0,
          name: '公告'
        },
        {
          id: 1,
          name: '通知'
        },
      ],
      dialogVisible: false,
      form: {
        page: 1,
        pageSize: 14,
      },
      form2: {
        title: '',
        type: 0,
        body: '',
      },
    }
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    /*选中*/
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    /*刷新*/
    select () {
      this.form.page = 1;
      this.getInfo();
    },
    /*确认删除*/
    isDelete () {
      let ids = this.multipleSelection.map(e => e.id);
      this.$nstand.ajax({
        method: 'post',
        url: '/api/Notice/Delete',
        data: {
          id: ids,
        },
        success: (response) => {
          const { data, success, message } = response.data;
          if (success) {
            this.$message({
              type: 'success',
              message: '删除成功',
              center: true,
            });
            this.getInfo();
          } else {
            this.$message({
              type: 'warning',
              message: message,
              center: true,
            });
          }
        }
      }, true)
    },
    /*初始化*/
    getInfo () {
      this.$nstand.ajax({
        method: 'get',
        url: '/api/Notice/GetNoticeList',
        params: this.form,
        success: (response) => {
          const { data, success, message } = response.data;
          if (success) {
            this.tableData = data.rows
            this.total = data.total
            this.$nextTick(() => {
              this.$refs.multipleTable.doLayout();
            })
          } else {
            this.$message({
              type: 'warning',
              message: message,
              center: true,
            })
          }
        }
      }, true)
    },
    /*改变每页size*/
    handleSizeChange (val) {
      this.form.pageSize = val;
      this.getInfo();
    },
    /*翻页*/
    handleCurrentChange1 (val) {
      this.form.page = val;
      this.getInfo();
    },
    /*删除*/
    Delete () {
      if (!this.multipleSelection.length < 1) {
        this.$nstand.confirmTip('确认删除', this.isDelete)
      } else {
        this.$message({
          type: 'warning',
          message: '请选择公告或通知',
          center: true,
        });
      }
    },
    /*添加*/
    add () {
      this.form2 = {
        title: '',
        type: 0,
        text: '',
      };
      this.dialogVisible = true;
    },
    /*确认添加*/
    isAdd () {
      this.$nstand.ajax({
        method: 'post',
        url: '/api/Notice/Save',
        data: this.form2,
        success: (response) => {
          const { data, success, message } = response.data;
          if (success) {
            this.$message({
              type: 'success',
              message: '添加成功',
              center: true,
            });
            this.dialogVisible = false;
            this.getInfo();
          } else {
            this.$message({
              type: 'warning',
              message: message,
              center: true,
            });
          }
        }
      }, true)
    }
  }
}
</script>


<style scoped>
.el-card >>> .el-table__body-wrapper::-webkit-scrollbar {
  /* 滚动条整体样式 */
  width: 17px; /* 高宽分别对应横竖滚动条的尺寸 */
  height: 1px;
}
.el-card >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  /* 滚动条里面小方块 */
  border-radius: 50px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
  background: #f2f6fc;
}
.el-card >>> .el-table__body-wrapper::-webkit-scrollbar-track {
  /* 滚动条里面轨道 */
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ffffff;
}
</style>